import React from "react";
import Card from "../../../../components/ui/Card";
import Button from "../../../../components/ui/Button";
import { PlusCircle, Link as LinkIcon } from "lucide-react";
import { mockCreator } from "../../../../data/mockData";
import RecentActivityList from "../../../../components/ui/RecentActivityList";

const MasterClassTab = ({ courses, onCreate }) => {
  const masterClassTransactions = mockCreator.mockTransactions
    .filter((txn) => txn.type === "MasterClass")
    .slice(0, 5);

  // ✨ CALCULATE STATS FOR THE CARDS
  // NOTE: We'll add a mock 'enrollments' property to our data for this calculation
  const totalEnrollments = courses.reduce(
    (acc, course) => acc + (course.enrollments || 50),
    0
  ); // Mocking 50 enrollments per course for now
  const totalRevenue = courses.reduce(
    (acc, course) => acc + course.priceETB * (course.enrollments || 50),
    0
  );
  const averageRevenue =
    totalEnrollments > 0 ? totalRevenue / totalEnrollments : 0;

  return (
    <div className="space-y-6">
      {/* ✨ NEW: "At-a-Glance" Analytics Cards ✨ */}
      <div className="grid grid-cols-1 @md:grid-cols-3 gap-4">
        <Card>
          <p className="text-sm text-slate-500">Total MasterClass Revenue</p>
          <p className="text-2xl font-bold text-slate-800">
            {totalRevenue.toLocaleString()} ETB
          </p>
        </Card>
        <Card>
          <p className="text-sm text-slate-500">Total Enrollments</p>
          <p className="text-2xl font-bold text-slate-800">
            {totalEnrollments.toLocaleString()}
          </p>
        </Card>
        <Card>
          <p className="text-sm text-slate-500">Avg. Revenue / Enrollment</p>
          <p className="text-2xl font-bold text-slate-800">
            {averageRevenue.toFixed(2)} ETB
          </p>
        </Card>
      </div>

      {/* --- Existing MasterClass List --- */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-slate-500">
            Manage MasterClasses you sell from "HIT: Hands-On Institute of
            Technology".
          </p>
          <Button variant="primary" onClick={onCreate}>
            <PlusCircle size={16} className="mr-2" /> Add MasterClass
          </Button>
        </div>
        <Card>
          <h3 className="text-lg font-semibold text-slate-800 mb-4">
            Your MasterClasses
          </h3>
          <div className="space-y-3">
            {courses.map((course) => (
              <div
                key={course.id}
                className="p-4 border border-slate-200 rounded-lg flex justify-between items-center"
              >
                <div>
                  <p className="font-medium text-slate-800">{course.title}</p>
                  <a
                    href={course.hitLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-primary hover:underline flex items-center"
                  >
                    <LinkIcon size={12} className="mr-1.5" />
                    {course.hitLink}
                  </a>
                </div>
                <p className="font-semibold text-slate-600">
                  {course.priceETB.toLocaleString()} ETB
                </p>
              </div>
            ))}
          </div>
        </Card>
      </div>

      {/* --- Existing Recent Activity List --- */}
      <RecentActivityList
        title="Recent MasterClass Activity"
        transactions={masterClassTransactions}
      />
    </div>
  );
};

export default MasterClassTab;
